import React, { useEffect, useState } from "react";
import { SnackbarProps } from "../interface/Success_SnackBar_Interface";
import "../styles/successInfoStyle.css";
import blueInfo from "../assets/images/accept_tick.png";
import snackCloseImg from "../assets/images/snack_close.png";
const GreenSuccessPopup: React.FC<SnackbarProps> = ({ message, onClose }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      onClose();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  if (!visible) return null;

  return (
    <div className="info-greensnackbarContainer">
      {/* Left border for success message */}
      <div className="info-greenleftBorder"></div>

      {/* Image and Text */}
      <div className="info-snackbarContent">
        <img src={blueInfo} alt="Success" className="info-icon" />
        <p className="info-text-bar">{message}</p>
      </div>

      {/* Close Icon */}
      <button
        onClick={() => {
          setVisible(false);
          onClose();
        }}
        className="closeButton"
      >
        <img src={snackCloseImg} alt="Close" className="info-closeIcon" />
      </button>
    </div>
  );
};

export default GreenSuccessPopup;
